<template>
  <div class="distribution">
    <van-nav-bar title="分销中心" />

    <!-- 分销数据 -->
    <div class="distribution_data">
      <van-image
        round
        width="60"
        height="60"
        :src="siteSupplierIndexData.user_portrait"
      />
      <div class="data_detail">
        <div class="detail_list">
          <div class="fs16">{{siteSupplierIndexData.user_nickname}}</div>
          <div v-if="siteSupplierIndexData.referree_user_nickname" class="fs12 m-t10">推荐人:{{siteSupplierIndexData.referree_user_nickname}}</div>
          <span  class="fs12" style="padding:5px;">{{siteSupplierIndexData.distributorLevel_name}}</span>
        </div>
        <van-icon name="setting-o" color="#fff" size="20" @click="toSetting()" />
      </div>
    </div>

    <van-cell
      title="编码: 5464561231"
      icon="/static/images/distribution_05.png"
    >
    </van-cell>

    <!-- 金额 -->
    <div class="distribution_number">
      <!-- <div class="number">
        <div>{{dbyuser.point}}{{siteSupplierIndexData.alreadyCash}}</div>
        <span class="fs12">登报云可提现佣金</span>
      </div> -->

      <div class="number number_last">
        <div class="number_left">
          <div>{{dbyuser.point}}</div>
          <span class="fs12 color000">登报云可提现佣金(元)</span>
        </div>
        <van-button color="#FD8000" size="small" @click="toDbyWithdraw"
          >佣金提现</van-button
        >
      </div>

      <div class="number number_last">
        <div class="number_left">
          <div>{{siteSupplierIndexData.canCash}}</div>
          <span class="fs12 color000">托管云可提现佣金(元)</span>
        </div>
        <van-button color="#FD8000" size="small" @click="toWithdraw"
          >佣金提现</van-button
        >
      </div>
    </div>

    <!-- 菜单栏 -->
    <van-grid
      :center="false"
      class="distribution_menu"
      direction="horizontal"
      :column-num="2"
    >
      <van-grid-item
        icon="/static/images/distribution_01.png"
        @click="toCommission"
      >
        <template #text>
          <div class="menu_list">
            分销佣金
            <div class="fs10 color999">{{siteSupplierIndexData.distributorCash}}元</div>
          </div>
        </template>
      </van-grid-item>
      <van-grid-item
        icon="/static/images/distribution_02.png"
        @click="toPayOrder"
      >
        <template #text>
          <div class="menu_list">
            分销订单
            <div class="fs10 color999">{{siteSupplierIndexData.distributorOrderCount}}笔</div>
          </div>
        </template>
      </van-grid-item>
      <van-grid-item
        icon="/static/images/distribution_03.png"
        @click="toWithdrawDetail"
      >
        <template #text>
          <div class="menu_list">
            提现明细
            <div class="fs10 color999">{{siteSupplierIndexData.cashOutCount}}笔</div>
          </div>
        </template>
      </van-grid-item>
      <van-grid-item
        icon="/static/images/distribution_04.png"
        @click="toMyCustomer"
      >
        <template #text>
          <div class="menu_list">
            我的顾客
            <div class="fs10 color999">{{siteSupplierIndexData.customersCount}}人</div>
          </div>
        </template>
      </van-grid-item>
    </van-grid>

    <van-cell
      title="推广二维码"
      icon="/static/images/distribution_06.png"
      @click="toCodeShare"
    >
      <template #right-icon>
        <van-icon name="arrow" color="#c3c3c3" class="search-icon" />
      </template>
    </van-cell>
  </div>
</template>
<script>
import { Button, NavBar } from "vant";
import { Grid, GridItem, Cell, CellGroup, Icon, Image } from "vant";
export default {
  components: {
    [Button.name]: Button,
    [NavBar.name]: NavBar,
    [Grid.name]: Grid,
    [GridItem.name]: GridItem,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Icon.name]: Icon,
    [Image.name]: Image,
  },
  data() {
    return {
      siteSupplierIndexData: [],
      userData: {
        nickname: "未登录",
        orderInfoCount_1: 0,
        orderInfoCount_2: 0,
        orderInfoCount_3: 0,
        orderInfoCount_5: 0,
        portrait: "",
        telephone: "",
      },
      dbyuser:{point:0},
    };
  },

  created() {
    this.siteSupplierIndex();
    this.getLoginUserInfo();
  },

  methods: {
//跳转账号设置界面
    toSetting() {
      this.$router.push({ path: "/personal/setting" });
    },

    // 员工管理-列表
    siteSupplierIndex() {
      var that = this;
      that.$api
        .distributorIndexAPI('')
        .then(function (res) {
          if (res.data.code === 200) {
            that.siteSupplierIndexData = res.data.data;
          }else{
            that.$router.push({ path: "/personal/superMembers" });
          }
        })
        .catch(function (err) {
          console.log("error");
        });
    },

    //跳转申请提现界面
    toWithdraw() {
      this.$router.push({ path: "/distribution/withdraw" });
    },

    //跳转分销佣金界面
    toCommission() {
      this.$router.push({ path: "/distribution/commission" });
    },

    //跳转分销订单界面
    toPayOrder() {
      this.$router.push({ path: "/distribution/payOrder" });
    },

    //跳转提现明细界面
    toWithdrawDetail() {
      this.$router.push({ path: "/distribution/withdrawDetail" });
    },

    //跳转我的顾客界面
    toMyCustomer() {
      this.$router.push({ path: "/distribution/myCustomer" });
    },

    //跳转推广二维码界面
    toCodeShare() {
      this.$router.push({ path: "/distribution/codeShare" , query: { id: this.siteSupplierIndexData.user_id }});
    },

    //跳转到登报云提现链接页面
    toDbyWithdraw(){

    },

    //获取登报云资料
    getDengBaoYunUserInfo(){
      let that = this
      that.$axios.get("https://my.1688tg.com/dengbao/Api/getUserData?phone="+this.userData.telephone).then(res => {
        //获取你需要用到的数据
       console.log('dbyuser',res)
       res = JSON.parse(res.data.data)
       that.dbyuser = res
      })
    },

    //获取登录用户信息
    getLoginUserInfo() {
      let that = this;
      that.$api
        .getLoginUserInfo("")
        .then(function (res) {
          if (res.data.code === 200) {
            that.userData = res.data.data;
            that.getDengBaoYunUserInfo()
          }
        })
        .catch(function (err) {
          console.log("error", err);
        });
    },
  },
};
</script>

<style lang="less">
.distribution {
  background: #f3f3f3;
  height: 100%;
  //分销数据
  .distribution_data {
    padding: 15px;
    background: #74a4f4;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .data_detail {
      width: 270px;
      display: flex;
      justify-content: space-between;
      color: #fff;

      .detail_list {
        display: flex;
        flex-flow: column; //垂直排列
        justify-content: space-between; //两端对齐

        > span {
          width: 60px;
          text-align: center;
          border: 1px solid #fff;
          padding: 2px 0px;
          border-radius: 5px;
          margin-top: 10px;
        }
      }
    }
  }

  // 金额
  .distribution_number {
    background: #fff;
    display: flex;
    padding: 10px 0px;
    margin-bottom: 15px;
    flex-direction: column;

    .number {
      padding: 15px 20px;

      > div {
        font-size: 25px;
        color: #74a4f8;
      }
    }

    .number:nth-of-type(1) {
      border-bottom: 1px solid #f3f3f3;
    }

    .number_last {
      display: flex;
      justify-content: space-between;
      align-items: center;

      .van-button {
        font-size: 12px;
        color: #fff;
        border-radius: 4px;
      }
    }
  }

  // 菜单栏
  .distribution_menu {
    .van-grid-item__content {
      padding: 16px 15px;
    }

    .menu_list {
      font-size: 14px;
      margin-left: 10px;
    }
  }

  .van-cell {
    display: flex;
    align-items: center;
    margin: 10px 0px;

    .van-cell__left-icon,
    .van-cell__right-icon {
      height: unset;
      font-size: 20px;
      line-height: unset;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/layout/distribution/index.vue